import PropTypes from "prop-types";
import { useState } from "react";
import { Snackbar, Alert, TextField, Box, InputAdornment, Icon } from "@mui/material";

function EmailAddressField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");
  // console.log(options);

  return (
    <Box>
      <TextField
        name={fieldRef}
        margin="dense"
        label={displayName}
        type="email"
        fullWidth
        variant="outlined"
        onBlur={(e) => {
          const entryValue = e.target.value;
          const re = /\S+@\S+\.\S+/;
          if (!re.test(entryValue)) {
            e.target.value = null;
            setErrMsg(`${displayName} must be a valid email format.`);
            showFieldError(true);
          }
        }}
        options={options}
        InputProps={{
          startAdornment: <InputAdornment position="start"><Icon>email</Icon></InputAdornment>,
        }}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
}

// Typechecking props of the Transaction
EmailAddressField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

EmailAddressField.defaultProps = {
  options: null,
};

export default EmailAddressField;
